import {UiFieldBaseSchema} from "./UiField";
import {z} from "zod";

export const SwitchFieldSchema = UiFieldBaseSchema.extend({
    componentType: z.literal('SwitchField'),
});

export type SwitchField = z.infer<typeof SwitchFieldSchema>;